<div
  #inputField
  contenteditable="true"
  [innerHTML]="
    value
      ? escapeHtml(value)
          .replaceAll('\{\{', '<strong>\{\{')
          .replaceAll('\}\}', '\}\}</strong>')
      : ''
  "
  [attr.placeholder]="placeholder"
  class="brn-input"
  (input)="handleInput()"
  (blur)="handleBlur()"
></div>
